// extracted by mini-css-extract-plugin
export default {"hideTooltip":"W_-z","fadeIn":"X_-z","delay":"Y_-z","recommendedSizeTooltip":"Z_-z"};